import { IEntity } from '../types';
import { EntityService } from './EntityService';

export class RiskAppIncidentTypeService extends EntityService<IEntity> {
    constructor() {
        super(`/RiskAppIncidentTypes`);
    }
}